module.exports = __webpack_public_path__ + "static/media/masala-veggie-burger-mb-fr.ae0ac518.jpg";